import { z } from 'zod'

import { FIRST_PAGE_INDEX, MAX_PAGE_INDEX } from './constants'

const pageNumberSchema = z.coerce.number().int().positive().default(FIRST_PAGE_INDEX)

/**
 * Parse page number from search params on frontend
 */
export function getPageFromSearchParam(param: string | null): number {
    if (param === null) {
        return FIRST_PAGE_INDEX
    }

    const parsedPage = pageNumberSchema.safeParse(param)
    if (parsedPage.success) {
        return Math.min(parsedPage.data, MAX_PAGE_INDEX)
    }

    console.error('Invalid page number', param)

    return FIRST_PAGE_INDEX
}

export function updatePageQueryParam(page: number) {
    window.history.replaceState(null, '', `?page=${page}`)
}
